import { Callback, NewsData } from '../../types/interfaces';
import { MESSAGES } from "../../types/MESSAGES";
import { AppView } from '../view/appView';

export class Loader {
    public baseLink: string;
    public options: Record<string, string>;
    constructor(baseLink: string, options: Record<string, string>) {
        this.baseLink = baseLink;
        this.options = options;
    }

    getResp(
        { endpoint = '', options = {} },
        callback = (data: NewsData):void => {
            data;
            console.error('No callback for GET response');
        }
    ):void {
        this.load('GET', endpoint, callback, options);
    }

    errorHandler(res: Response): Response|never {
        if (!res.ok) {
            if (res.status === 401 || res.status === 404)
                console.log(`Sorry, but there is ${res.status} error: ${res.statusText}`);
            if (res.status === 429 || res.status === 426) {
                res.json().then(data => console.log(`Sorry, but there is ${res.status} error: ${data.message}`));
                AppView.showInfo(MESSAGES.ManyRequest);
            }
            throw Error(res.statusText);
        }
        return res;
    }

    makeUrl(options = {}, endpoint = ''):string {
        const urlOptions: {[key: string]:string} = { ...this.options, ...options };
        let url = `${this.baseLink}${endpoint}?`;

        Object.keys(urlOptions).forEach((key): void => {
            url += `${key}=${urlOptions[key]}&`;
        });

        return url.slice(0, -1);
    }

    load(method: string, endpoint: string, callback: Callback<NewsData>, options = {}):void {
        fetch(this.makeUrl(options, endpoint), { method })
            .then(this.errorHandler)
            .then((res):Promise<NewsData> => res.json())
            .then((data):void => callback(data))
            .catch(():void => AppView.showInfo(MESSAGES.ManyRequest))
    }
}
